import React, { useEffect, useRef, useState } from 'react'

import ArrowDownNew from '../../icons/ArrowDownNew'
import styles from './FiltersDropdownNew.module.scss'
import { FiltersDropdownNewTypes, Option } from './FiltersDropdownNew.types'

export const FiltersDropdownNew: React.FC<FiltersDropdownNewTypes> = ({
  options,
  onSelect,
  label,
  selected,
  btnText = 'Не важно',
  name = '',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState<Option | null>(null)
  const ref = useRef<HTMLDivElement | null>(null)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleSelect = (option: Option) => {
    setSelectedOption(option)
    onSelect(option.value, name)
    setIsOpen(false)
  }

  useEffect(() => {
    if (selected) {
      setSelectedOption(selected)
    }
  }, [selected])

  useEffect(() => {
    const onClick = (e: any) => {
      if (!ref.current) return

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      if (!ref.current.contains(e.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('click', onClick)
    return () => document.removeEventListener('click', onClick)
  }, [])

  return (
    <div className={styles.dropdown} ref={ref}>
      {label && <p className={styles.dropdownLabel}>{label}</p>}
      <button className={styles.dropdownButton} onClick={handleToggle}>
        <span className={styles.dropdownButtonRow}>
          <span className={styles.dropdownButtonSpan}>
            {selectedOption ? selectedOption.label : btnText}
          </span>
          <ArrowDownNew />
        </span>
      </button>
      {isOpen && (
        <ul className={styles.dropdownOptions}>
          {options.map(option => (
            <li
              key={option.value}
              className={[
                styles.dropdownOption,
                selectedOption?.value === option.value
                  ? styles['dropdownOption--selected']
                  : '',
              ].join(' ')}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
